import React from "react";
import {Helmet} from "react-helmet";

export default function BatAndHorse() {
    return (
        <div>
            <Helmet>
                <title>蝙蝠与马 Bat And Horse</title>
            </Helmet>
            <h6 className="App-essay-title">蝙蝠与马</h6>
            <p className="App-essay-article">
                <br/>
                <b>二〇二五 七月</b>
                <br/><br/>
                小时候，西安的夜市上，清一色挂着一排红色塑料灯罩笼罩的白炽灯泡，摊儿上的烤肉看过去一片火红。电风扇中间，绑着一根绕成绳的红色塑料袋，用来驱赶蚊蝇，但蚊蝇依旧。
                <br/><br/>
                那天晚上放学，我妈骑着一辆高速奔驰的摩托，接我回家，去找我爸。她带着我，风一般穿过夜市。我清楚地记得，夜幕中，有许多蝙蝠在夜的黑影里，倒挂在烤肉摊的双色电线上，收拢翅膀，像一排硕大的橄榄。蝙蝠们是孙子兵法描绘的阵仗：其疾如风，其徐如林，侵掠如火，不动如山，难知如阴。
                <br/><br/>
                其中一只突然朝我飞过来，用宽大的翅膀扫过我脑袋，撞击后陡然一惊，迅速变换飞行姿态，然后消失在夜幕中。它像头张开双鳍的座头鲸，在搁浅前袖拂海峡，然后又回到大洋中。
                <br/><br/>
                我当时很小，妈带我穿过夜市，夜市空气里弥漫着三百二十七种味道，和各种吵闹的噪音和歌声，但我都忘得一干二净。但那只蝙蝠我记得很清楚，那只宽大，瘦骨嶙峋的蝙蝠翅膀。
                <br/><br/>
                那是小学五年级，第二天上课，老师说蝙蝠靠超声波的回声定位，准确敏捷，可以优雅地避开任何障碍物。我举手说：“不对！ 昨天就有只蝙蝠用翅膀拍到我脑袋。”同学和老师哄堂大笑，我有点儿尴尬脸红，但心里在想：“你们懂个屁！”
                <br/><br/>
                我八岁的时候，舅舅把我放在一匹枣红色的马上，那匹马在马场的土地上突然加速，在弯道上贴地飞行，马后扬起一片黄土飞尘，快到终点时，马突然刹车直立，岿然不动。我吓得脸色惨白，舅舅把我抱下马，哈哈大笑。
                <br/><br/>
                我把上面这段文字输入谷歌的最新AI大模型Veo，谷歌给我生成了一段30秒的视频：一个金发碧眼的白人小男孩，被一个白人男子抱上一匹马，一匹枣红色油光水滑的骏马。骏马跑过弯道，停在马场的尽头，男人哈哈大笑。
                <br/><br/>
                我单眼皮，黄皮肤、黑头发、黑眼睛，眉毛浓密，长相普通。但我比你那张金发碧眼的脸，帅多了。

            </p>

            <br/>

            <h6 className="App-essay-title">Bat And Horse</h6>
            <p className="App-essay-article">
                <br/>
                <b>Jul 2025</b>
                <br/><br/>

            </p>
        </div>)
}
